import { render, staticRenderFns } from "./ContactRelatedList.vue?vue&type=template&id=d04c7c28"
import script from "./ContactRelatedList.vue?vue&type=script&lang=js"
export * from "./ContactRelatedList.vue?vue&type=script&lang=js"
import style0 from "./ContactRelatedList.vue?vue&type=style&index=0&id=d04c7c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports